import { render, staticRenderFns } from "./LiveDelegateDataList.vue?vue&type=template&id=47858278"
import script from "./LiveDelegateDataList.vue?vue&type=script&lang=js"
export * from "./LiveDelegateDataList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports